import React from 'react'
import PropTypes from 'prop-types'
import DateTimeInput from './../Form/DateTimeInput.jsx'
import SelectInput from './../Form/SelectInput.jsx'
import RadioListInput from './../Form/RadioListInput.jsx'
import TextInput from './../Form/TextInput.jsx'
import TextArea from '../Form/TextArea.jsx'
import { CustomLoader } from '../../loader'
import { prepareMaterialsOptions } from './helpers'
import moment from 'moment'
import { DATE_TIME_FORMAT, dateTimeFormatToIsoDateTime } from '../../services/utils/dateTime'
import { _ } from '../../gettext'
import options from '@spa/utils/options'

export default class Form extends React.Component {
  static propTypes = {
    reservation: PropTypes.object,
    form: PropTypes.object,
    ticketId: PropTypes.string,
    errors: PropTypes.array,
    priceTime: PropTypes.number,
    priceMaterial: PropTypes.number,
    priceReservation: PropTypes.number,
    favourites: PropTypes.object,
    researchGroups: PropTypes.object,
    projects: PropTypes.object,
    contacts: PropTypes.object,
    services: PropTypes.object,
    servicesLoading: PropTypes.bool,
    materials: PropTypes.object,
    materialsLoading: PropTypes.bool,
    isLoggedUserInRoleAdmin: PropTypes.bool.isRequired,
    canEditRealisedFor: PropTypes.bool,
    canEditPrivateDescription: PropTypes.bool.isRequired,
    onChange: PropTypes.func,
    handleToggleRealisedFor: PropTypes.func,
    handleToggleCard: PropTypes.func,
  }

  render () {
    const { reservation, form } = this.props

    return (
      <div>
        {Object.keys(this.props.errors).map((key) => {
          return (
            <div className="alert alert-danger" key={key}>
              {this.props.errors[key]}
            </div>
          )
        })}
        <div className="card mb-3">
          <div className="card-header">{_('Základní údaje')}</div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-4">
                <label>{_('Začátek:')}</label>
                <DateTimeInput
                  name="from"
                  placeholder={_('Vyberte začátek')}
                  required={true}
                  value={form.from}
                  maxDate={reservation ? form.to : null}
                  onChange={(name, value) => {
                    this.props.onChange(name, value)
                    if (form.to === null || reservation === null) {
                      this.props.onChange('to',
                        moment(dateTimeFormatToIsoDateTime(value))
                          .add(1, 'hour')
                          .format(DATE_TIME_FORMAT)
                      )
                    }
                  }}
                />
              </div>
              <div className="col-md-4">
                <label>{_('Konec:')}</label>
                <DateTimeInput
                  name="to"
                  placeholder={_('Vyberte konec')}
                  required={true}
                  value={form.to}
                  minDate={reservation ? form.from : null}
                  onChange={this.props.onChange}
                />
              </div>
              <div className="col-md-4">
                <label>{_('Přístroje:')}</label>
                <SelectInput
                  name="equipment"
                  options={this.props.favourites}
                  placeholder={_('-- Vyberte přístroje --')}
                  value={form.equipment}
                  multiple={true}
                  required={true}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4">
                <label>{_('Výzkumná skupina:')}</label>
                <SelectInput
                  name="researchGroup"
                  options={this.props.researchGroups}
                  value={form.researchGroup}
                  placeholder={_('-- Vyberte skupinu --')}
                  required={true}
                  onChange={this.props.onChange}
                />
              </div>
              <div className="col-md-4">
                <label>{_('Projekt:')}</label>
                <SelectInput
                  name="project"
                  options={this.props.projects}
                  value={form.project}
                  placeholder={_('-- Vyberte projekt --')}
                  allowClear={true}
                  onChange={this.props.onChange}
                />
              </div>
              <div className="col-md-4">
                <label>{_('Status:')}</label>
                <SelectInput
                  name="statusCode"
                  options={options.reservationStatuses}
                  value={form.statusCode}
                  placeholder={_('-- Vyberte status --')}
                  required={true}
                  onChange={(key, value) => this.props.onChange(key, parseInt(value))}
                  disabled={this.props.isLoggedUserInRoleAdmin === false}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-12">
                <label>{_('Popis:')}</label>
                <TextArea
                  name="description"
                  value={form.description}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-12">
                <label>{_('Typ rezervace:')}</label>
                <RadioListInput
                  name="timeRequirement"
                  options={this.props.isLoggedUserInRoleAdmin
                    ? options.timeRequirements : options.shortTimeRequirements}
                  value={form.timeRequirement}
                  required={true}
                  allowClear={true}
                  onChange={(key, value) => this.props.onChange(key, parseInt(value))}
                />
              </div>
            </div>
            {parseInt(form.timeRequirement) === 6 ? (
              <div className="row mb-3">
                <div className="col-md-6">
                  <label>{_('Počet vzorků:')}</label>
                  <TextInput
                    type="number"
                    name="psa_additionalrequestcapacity"
                    required={true}
                    placeholder={_('Počet vzorků:')}
                    value={form.psa_additionalrequestcapacity}
                    onChange={(key, value) => this.props.onChange(key, parseInt(value))}
                  />
                </div>
                {!this.props.ticketId ? (
                  <div className="col-md-6">
                    <label>{_('Požadavek:')}</label>
                    <br />
                    <SelectInput
                      name="new_service_ticket"
                      options={reservation && reservation.formData.new_service_ticket ? {
                        [reservation.formData.new_service_ticket]: reservation.model.new_service_ticket.Name
                      } : {}}
                      value={form.new_service_ticket}
                      allowClear={true}
                      placeholder={_('-- Stejný jako přihlášený uživatel --')}
                      ajaxUrl="/api-deprecated/service-ticket/pairs/"
                      onChange={this.props.onChange}
                    />
                  </div>
                ) : null}
              </div>
            ) : null}
            <div className={'realised-for' + (this.props.isLoggedUserInRoleAdmin ? '' : ' d-none')}>
              <label>{_('Realizováno pro:')}</label>
              <div className="row">
                <div className="col-md-6">
                  <div className="realised-for-existing">
                    <SelectInput
                      name="realisedFor"
                      options={this.props.contacts}
                      value={form.realisedFor}
                      disabled={this.props.canEditRealisedFor === false}
                      allowClear={true}
                      placeholder={_('-- Stejný jako přihlášený uživatel --')}
                      ajaxUrl="/ajax/contact-pairs/"
                      onChange={this.props.onChange}
                    />
                  </div>
                  <div className="realised-for-new d-none">
                    <TextInput
                      name="realisedForFirstname"
                      className="mb-3"
                      required={form.createRealisedFor}
                      placeholder={_('Jméno')}
                      value={form.realisedForFirstname}
                      disabled={this.props.canEditRealisedFor === false}
                      onChange={this.props.onChange}
                    />
                    <TextInput
                      name="realisedForLastname"
                      className="mb-3"
                      required={form.createRealisedFor}
                      placeholder={_('Příjmení')}
                      value={form.realisedForLastname}
                      disabled={this.props.canEditRealisedFor === false}
                      onChange={this.props.onChange}
                    />
                    <TextInput
                      name="realisedForEmail"
                      className="mb-3"
                      required={form.createRealisedFor}
                      placeholder={_('E-mail')}
                      value={form.realisedForEmail}
                      disabled={this.props.canEditRealisedFor === false}
                      onChange={this.props.onChange}
                    />
                    <SelectInput
                      name="realisedForInstitution"
                      options={{}}
                      value={form.realisedForInstitution}
                      allowClear={true}
                      placeholder={_('-- Vyberte instituci --')}
                      ajaxUrl="/ajax/account-pairs/"
                      disabled={this.props.canEditRealisedFor === false}
                      onChange={this.props.onChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <button className="btn btn-primary"
                    disabled={this.props.canEditRealisedFor === false}
                    onClick={this.props.handleToggleRealisedFor}>
                    {_('Nový kontakt')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'card' + (this.props.reservation !== null ? ' mb-3' : '')}>
          <div className="card-header">
            <a href="#"
              onClick={(e) => this.props.handleToggleCard(e, '.card-body-details')}>
              {_('Podrobnosti')}
              <i className="fal fa-angle-double-down float-right"></i>
            </a>
          </div>
          <div className="card-body card-body-details" style={{ display: 'none' }}>
            <div className="mb-3">
              <label>{_('Účastníci měření:')}</label>
              <SelectInput
                name="additionalContacts"
                options={this.props.reservation !== null ? this.props.reservation.additionalContacts : {}}
                value={form.additionalContacts}
                placeholder={_('-- Vyberte účastníky --')}
                multiple={true}
                ajaxUrl="/ajax/contact-pairs/"
                onChange={this.props.onChange}
              />
            </div>
            <div className="mb-3 position-relative input-group">
              <label>{_('Služba:')}</label>
              <SelectInput
                name="service"
                options={this.props.services}
                value={form.service}
                placeholder={_('-- Vyberte službu --')}
                onChange={this.props.onChange}
              />
              { this.props.servicesLoading === true ? <CustomLoader /> : null }
            </div>
            <div className="mb-3 position-relative input-group">
              <label>{_('Materiál:')}</label>
              <SelectInput
                name="materials"
                options={prepareMaterialsOptions(this.props.materials)}
                multiple={true}
                value={form.materials}
                placeholder={_('-- Vyberte materiál --')}
                onChange={this.props.onChange}
              />
              {this.props.materialsLoading === true ? (
                <i className="fal fa-spinner fa-spin fa-spinner-multiple" />
              ) : null}
            </div>
            <div className="mb-3">
              <label>{_('Cena:')}</label><br />
              {_('Celková:')} <strong>{(this.props.priceTime + this.props.priceReservation + this.props.priceMaterial).toLocaleString()} Kč</strong><br />
              {_('Za rezervační část:')} <strong>{(this.props.priceReservation).toLocaleString()} Kč</strong><br />
              {_('Za čas:')} <strong>{(this.props.priceTime).toLocaleString()} Kč</strong><br />
              {_('Za materiál:')} <strong>{(this.props.priceMaterial).toLocaleString()} Kč</strong>
            </div>
            <div className={this.props.canEditPrivateDescription === false ? 'd-none' : ''}>
              <label>{_('Neveřejný popis:')}</label>
              <TextArea
                name="privateDescription"
                value={form.privateDescription}
                onChange={this.props.onChange}
              />
            </div>
          </div>
        </div>
        <div className={'card' + (this.props.reservation === null ? ' d-none' : '')}>
          <div className="card-header">
            <a href="#" className="d-block"
              onClick={(e) => this.props.handleToggleCard(e, '.card-body-systems')}>
              {_('Systémové údaje')}
              <i className="fal fa-angle-double-down float-right"></i>
            </a>
          </div>
          <div className="card-body card-body-systems" style={{ display: 'none' }}>
            <div className="row mb-3">
              <div className="col-md-6">
                <strong>{_('Vytvořeno:')}</strong><br />
                {this.props.reservation ? this.props.reservation.formData.createdon : ''}
              </div>
              <div className="col-md-6">
                <strong>{_('Vytvořil:')}</strong><br />
                {this.props.reservation ? this.props.reservation.model.createdby.Name : ''}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <strong>{_('Poslední změna:')}</strong><br />
                {this.props.reservation ? this.props.reservation.formData.modifiedon : ''}
              </div>
              <div className="col-md-6">
                <strong>{_('Naposledy změnil:')}</strong><br />
                {this.props.reservation ? this.props.reservation.model.modifiedby.Name : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
